import type {Vector2, Vector2Like} from "@cm/math"

export enum BoundaryDirection {
    Horizontal = 0,
    Vertical = 1,
}

export type ChangeEvent = {
    type: "point-added" | "point-removed" | "point-source-position-moved" | "point-result-uv-moved"
}

export enum ViewMode {
    Source = "source",
    Result = "result",
}

export type ComputeSnapPositionFn = (parameters: {position: Vector2; referencePosition: Vector2 | undefined} | undefined) => Promise<Vector2Like | undefined>
